import { SET_ACTIVE_TAB } from "redux/types";

const setActiveTab = (payload) => {
  return { type: SET_ACTIVE_TAB, payload };
};

export { setActiveTab };
